(() => {
  const breakpoint = window.matchMedia('(max-width: 768px)');
  let mySlider;
  const initSwiper = () => {
    mySlider = new Swiper('.js-text-with-icon-swiper', {
      effect: 'fade',
      slidesPerView: 'auto',
      spaceBetween: 0,
      allowTouchMove: false,
      navigation: {
        nextEl: ".js-text-with-icon-button-next",
        prevEl: ".js-text-with-icon-button-prev",
      },
      pagination: {
        el: ".js-text-with-icon-pagination",
        clickable: false
      }
    });
  }

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      return initSwiper();
    } else {
      if (mySlider !== undefined) mySlider.destroy(true, true);
    }
  };

  breakpoint.addEventListener('change', breakpointChecker);
  breakpointChecker();
})();